
/* Material */
import Pagination from '@mui/material/Pagination'
import PaginationItem from '@mui/material/PaginationItem'
import { useRouter } from 'next/router'
import TextField from '@mui/material/TextField'
import MenuItem from '@mui/material/MenuItem'
import useStyles from './Products.styles'

/* Redux */
import Redux from './Products.Redux'
import { listingPagePath } from 'src/functions/listingSeo'

interface Props {
  page: number
  size: number
  count: number
}

const ProductsPagination: React.FC<Props> = ({ page, size, count }) => {
  const classes = useStyles()
  const router = useRouter()
  const { changeFilterPage, changeFilterSize, activeFilters, activeBrands } = Redux()
  const routePath = (router.asPath || '').split(/[?#]/)[0]
  // Only the default catalog order has stable, server-rendered page URLs.
  // Personal filter selections stay local and must not advertise a different
  // unfiltered result set through a misleading link.
  const crawlable = /^\/(m|b)\//.test(routePath) && size === 24
    && !router.query.suche && !Object.keys(activeFilters).length && !activeBrands.length

  const pagesCount = Math.ceil(count / size)

  return <div className={classes.paginationWrapper}>

    <Pagination 
      aria-label='Produktseiten'
      color='primary' className={classes.pagination}
      page={page} count={pagesCount}
      getItemAriaLabel={(type, value) => type === 'page'
        ? `Seite ${value}` : type === 'next' ? 'Nächste Seite' : type === 'previous' ? 'Vorherige Seite' : type === 'first' ? 'Erste Seite' : 'Letzte Seite'}
      renderItem={item => crawlable && item.page && !item.disabled && !item.type.includes('ellipsis')
        ? <PaginationItem {...item} component='a' href={listingPagePath(routePath, item.page)} aria-current={item.selected ? 'page' : undefined} />
        : <PaginationItem {...item} />}
      onChange={(event,nextPage)=>{
        if (crawlable) {
          const mouseEvent = event as React.MouseEvent
          if (mouseEvent.metaKey || mouseEvent.ctrlKey || mouseEvent.shiftKey || mouseEvent.altKey) return
          event.preventDefault()
          void router.push(listingPagePath(routePath, nextPage))
          return
        }
        changeFilterPage(nextPage)
        window.scrollTo(0,106) // TODO: Richtige Herader-Höhe
      }}
    />

    <div className={classes.pageLimit}>
      Zeige {' '}
      <TextField
        select variant='standard'
        value={size}
        SelectProps={{ SelectDisplayProps: { 'aria-label': 'Produkte pro Seite' } }}

        onChange={({target:{value}}) => {
          changeFilterSize(Number(value) || size)
        }}
      >

        {[24,48,72,96].map(limit=>
          <MenuItem 
            key={limit}
            value={limit}
          >
            {limit}
          </MenuItem>
        )}

      </TextField>
      {' '} pro Seite
    </div>

  </div>

}

export default ProductsPagination
